import { UseInfiniteQueryResult } from "@tanstack/react-query";
import { RefObject } from "react";

import Content from "./Content";
import { SearchBar } from "./SearchBar";

import { Request } from "@/types/requests";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarHeader,
} from "@/components/ui/sidebar";

interface SecondarySidebarProps {
  title?: string;
  children?: React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onItemSelect?: (item: any) => void;
  inputRef?: RefObject<HTMLInputElement | null>;
  requestsOn?: boolean;
  requests?: Request[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  requestLogs?: UseInfiniteQueryResult<any, unknown>;
  onRefresh?: () => void;
  secondarySidebarOpen?: boolean;
  onSearchActiveChange?: (isActive: boolean) => void;
}

const SecondarySidebar = ({
  title = "Secondary Navigation",
  children,

  inputRef,
  requestsOn,
  requests,
  requestLogs,
  onRefresh,
  secondarySidebarOpen = true,
  onSearchActiveChange,
}: SecondarySidebarProps) => {
  const hasRequestData = inputRef && typeof requestsOn === "boolean" && requests && requestLogs;

  const sidebarBody = (
    <>
      <SidebarHeader className="flex min-h-16 items-center justify-center border-b bg-white/50 px-3 py-1.5">
        <SearchBar
          inputRef={inputRef!}
          requestsOn={requestsOn!}
          onRefresh={onRefresh}
          onSearchActiveChange={onSearchActiveChange}
        />
      </SidebarHeader>

      <SidebarContent className="flex flex-col overflow-hidden">
        <SidebarGroup className="flex min-h-0 flex-1 flex-col overflow-hidden px-0 py-0">
          <SidebarGroupContent className="flex min-h-0 flex-1 flex-col overflow-hidden">
            <Content
              inputRef={inputRef!}
              requestsOn={requestsOn!}
              requests={requests!}
              requestLogs={requestLogs!}
              secondarySidebarOpen={secondarySidebarOpen}
            />
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </>
  );

  return (
    <Sidebar
      side="left"
      className="bg-gray-50/50"
      collapsible="none"
      style={{
        width: "100%",
        maxWidth: "100%",
      }}
    >
      {hasRequestData ? (
        sidebarBody
      ) : (
        <>
          <SidebarHeader className="border-b bg-white/50">
            <div className="px-4 py-3">
              <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
            </div>
          </SidebarHeader>

          <SidebarContent>
            <SidebarGroup>
              <SidebarGroupContent>
                {children ? (
                  children
                ) : (
                  <div className="px-4 py-6 text-center">
                    <div className="text-sm text-muted-foreground">No content available</div>
                    <div className="mt-2 text-xs text-muted-foreground/70">
                      Select an item from the main sidebar
                    </div>
                  </div>
                )}
              </SidebarGroupContent>
            </SidebarGroup>
          </SidebarContent>
        </>
      )}
    </Sidebar>
  );
};

export default SecondarySidebar;
